import type { FaqItem } from "@/lib/blog";

type Props = {
  items: FaqItem[];
  eyebrow: string;
  headline: string;
};

export function BlogFAQ({ items, eyebrow, headline }: Props) {
  if (!items.length) return null;
  return (
    <section className="mt-20">
      <p className="eyebrow mb-4">{eyebrow}</p>
      <h2 className="font-display text-3xl md:text-4xl text-ink mb-10 editorial-italic">
        <em>{headline}</em>
      </h2>
      <div className="divide-y divide-rule border-t border-b border-rule">
        {items.map((it, i) => (
          <details
            key={i}
            className="group py-6 [&_summary::-webkit-details-marker]:hidden"
          >
            <summary className="cursor-pointer list-none flex items-start justify-between gap-6">
              <h3 className="font-display text-lg md:text-xl text-ink leading-snug">
                {it.q}
              </h3>
              <span
                aria-hidden
                className="mt-1 font-mono text-cyan-deep text-lg select-none transition-transform group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <div className="mt-4 max-w-3xl text-ink-2 leading-relaxed">
              {it.a.split("\n\n").map((p, j) => (
                <p key={j} className={j > 0 ? "mt-3" : ""}>
                  {p}
                </p>
              ))}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
